import { useState } from "react"
import { useLocalObservable } from "mobx-react"
import { observer } from "mobx-react-lite"
import { useForm } from "antd/es/form/Form"
import { SaveOutlined } from "@ant-design/icons"
import { choose } from "choose-matching"

import { configStore } from "@src/app/configStore"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { InvoiceEntity } from "@src/pages/paymentLinksCreate/classes/InvoiceEntity"
import { InvoiceCreateSuccess } from "@src/pages/paymentLinksCreate/ui/InvoiceCreateSuccess"
import { PaymentLinkForm } from "@src/pages/paymentLinksCreate/ui/PaymentLinkForm"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"
import { useCatchFormErrors } from "@src/shared/form/base_error"

export const PaymentLinksCreatePage = observer(() => {
  const {
    config: { payment_page_url },
    isLoading,
  } = configStore

  const invoice = useLocalObservable(() => new InvoiceEntity())

  const [form] = useForm()

  const [isCreated, setIsCreated] = useState(false)

  const { submit } = useCatchFormErrors(form, () =>
    invoice.create(form.getFieldsValue()).then((data) => {
      setIsCreated(Boolean(data?.id))
    }),
  )

  return (
    <>
      {choose(
        [
          isCreated,
          <InvoiceCreateSuccess
            invoice={invoice}
            paymentPageUrl={payment_page_url}
          />,
        ],
        [
          true,
          <DefaultPageLayout
            button={
              <SubmitButton
                buttonProps={{
                  icon: <SaveOutlined />,
                  loading: invoice.isLoading,
                  onClick: submit,
                  size: "large",
                  type: "primary",
                }}
                form={form}
              >
                Save
              </SubmitButton>
            }
            isLoading={isLoading}
            title="Create a payment link"
          >
            <PaymentLinkForm
              form={form}
              isLoading={invoice.isLoading}
              projects={invoice.projects}
            />
          </DefaultPageLayout>,
        ],
      )}
    </>
  )
})
